import { supabase } from "../../supabase/supabase";

export async function runAllMigrations(organizationId?: string) {
  try {
    // Get authentication token
    const { data: sessionData } = await supabase.auth.getSession();
    const accessToken = sessionData.session?.access_token;

    if (!accessToken) {
      throw new Error("Authentication required. Please log in again.");
    }

    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !supabaseAnonKey) {
      throw new Error("Supabase configuration is missing");
    }

    // Prepare request body with organization ID if provided
    const requestBody: Record<string, any> = {};

    // Only add organization_id if it's provided and not empty
    if (organizationId) {
      requestBody.organization_id = organizationId;
    }

    // Call the Supabase REST API to run migrations
    const response = await fetch(`${supabaseUrl}/rest/v1/rpc/run_migrations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        apikey: supabaseAnonKey,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Failed to run migrations: ${JSON.stringify(errorData)}`);
    }

    const result = await response.json();
    return { success: true, data: result };
  } catch (error) {
    console.error("Error running migrations:", error);
    return { success: false, error: error.message };
  }
}
